// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3Ov8g","validationTips":"StatementDescriptor_validationTips__3lhzT"};